module.exports = __webpack_public_path__ + "static/media/creative_02.c6ef4aae.jpg";